import { render, staticRenderFns } from "./PasswordRecoveryTokenView.vue?vue&type=template&id=2171ef35&"
import script from "./PasswordRecoveryTokenView.vue?vue&type=script&lang=ts&"
export * from "./PasswordRecoveryTokenView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports